module.exports = __webpack_public_path__ + "img/rollTimes.3e39a48b.png";